import { __awaiter, __decorate, __generator, __metadata } from "tslib";
import { Component, Input } from 'angular-ts-decorators';
import template from './search-box.html';
var SearchBoxComponent = (function () {
    function SearchBoxComponent(coveoSearchService, localeService) {
        this.coveoSearchService = coveoSearchService;
        this.localeService = localeService;
        this.interfaceLanguage = this.coveoSearchService.getInterfaceLanguage();
    }
    SearchBoxComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var searchInterface;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setRedirectionUrl();
                        this.coveoSearchService.setCoveoModulesUrls(this.coveoHeadlessModuleUrl);
                        searchInterface = document.querySelector('#search-interface');
                        return [4, this.coveoSearchService.initSearchInterface(searchInterface, this.accessToken, this.organizationId)];
                    case 1:
                        _a.sent();
                        this.coveoSearchService.enableLanguageFiltering();
                        return [2];
                }
            });
        });
    };
    SearchBoxComponent.prototype.setRedirectionUrl = function () {
        var localePrefix = this.localeService.localePrefix();
        var redirectionUrl = localePrefix + "/support/search";
        var searchBoxElement = document.querySelector('atomic-search-box');
        searchBoxElement.setAttribute('redirection-url', redirectionUrl);
    };
    SearchBoxComponent.$inject = [
        'coveoSearchService',
        'localeService',
    ];
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchBoxComponent.prototype, "accessToken", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchBoxComponent.prototype, "organizationId", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchBoxComponent.prototype, "searchInterfacePipeline", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchBoxComponent.prototype, "searchInterfaceSearchHub", void 0);
    __decorate([
        Input(),
        __metadata("design:type", String)
    ], SearchBoxComponent.prototype, "coveoHeadlessModuleUrl", void 0);
    SearchBoxComponent = __decorate([
        Component({
            selector: 'searchBox',
            template: template,
        }),
        __metadata("design:paramtypes", [Object, Object])
    ], SearchBoxComponent);
    return SearchBoxComponent;
}());
export { SearchBoxComponent };
